<template>
    <div class="w-100 d-flex flex-column justify-content-between">
        <HeaderBar/>
        <div class="px-1 ">
            <div class="d-flex flex-column  mt-4 ">
                <div class="title d-flex justify-content-center align-items-center mt-2">
                    Configurar Perfíl
                </div> 
            </div>
            <div>
            <validation-observer ref="GanForm">
                <b-form class="auth-register-form " @submit.prevent="">
                    <b-form-group label="Nombre de usuario" label-for="productSystem" readonly="readonly" class=" w-100 mr-1">
                        <b-form-input id="productSystem" v-model="user.names" readonly/>
                    </b-form-group>
                    <b-form-group label="Documento" label-for="productSystem" class=" w-100 mr-1">
                        <b-form-input id="productSystem" v-model="user.poisition" />
                    </b-form-group>
                    <b-form-group label="Teléfono" label-for="productSystem" class=" w-100 mr-1">
                        <b-form-input id="productSystem" v-model="user.phone" />
                    </b-form-group>
                  
                    <div class="d-flex justify-content-center pb-5 ">
                        <b-button type="submit" v-on:click="updateAccount"
                            class="bg-primary dataButton  d-flex align-items-center justify-content-center w-75 ">
                            <div class=""> Actualizar mi cuenta </div>
                        </b-button>
                    </div>
                </b-form>
            </validation-observer>
            </div>
        </div>
        <ControlMenu />
    </div>
</template>

<script>
import ControlMenu from '@/components/ControlMenu.vue'
import HeaderBar from '@/components/HeaderBar.vue'
import vSelect from 'vue-select'
import axios from 'axios'
import "vue-select/dist/vue-select.css";
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { BRow, BCol, BFormTextarea,BFormSelect, BFormGroup, BFormInput, BForm, BImg, BButton, BFormCheckbox } from 'bootstrap-vue'
import { required } from '@validations'
import flatPickr from 'vue-flatpickr-component'

export default {
    components: {
        ControlMenu,
        flatPickr,
        BFormGroup,
        ValidationProvider,
        ValidationObserver,
        BFormGroup,
        HeaderBar,
        BFormInput,
        BForm,
        required,
        vSelect,
        BImg,
        BButton,
        BFormCheckbox,
        BFormTextarea,
        BFormSelect,
    },
    data() {
        return {
            Cancelationsoptions:[
                {value:1, text:'Tengo otra cuenta'},
                {value:2, text:'El app no fue útil'},
                {value:3, text:'Otro'}
            ],
            cancelationRequest:{
                description: '',
                option_id:null,
                user_id:localStorage.getItem('userID'),
            },
            user:{
                names:null,
                poisition:null,
                phone:null
            }
        }
    },
    methods: {
        async fetchProfileData(config){
            let id=localStorage.getItem('userID');
            fetch(this.$apiUrl+"view/users/"+id, config)
            .then(response => response.json())
            .then(result => {
                console.log(result)
                this.user = result.users
            })
        },

        updateAccount(){
            this.$refs.GanForm.validate().then(success => {
                if(success){
                    let self= this;
                    let id=localStorage.getItem('userID');
                    const token = localStorage.getItem("accessToken");
                    const config = {headers: {"X-Authorization": `Bearer ${token}`}};
                    this.$http.post("edit/users/"+id, this.user,config).then(() => {
                        this.$swal({
                            title: 'Configuración de cuenta',
                            text: 'Hemos actualizado tu cuenta de manera satisfactoria.',
                            type: 'success',
                            icon:'success',
                            showCancelButton: false,
                            confirmButtonColor:'#5E8F23',
                            showCloseButton: true,
                            showLoaderOnConfirm: false  
                        }).then(function(){
                            self.$router.replace({name:'home'});
                        });
                    }).catch(error => {
                        console.log(error)
                    });
                }
            });
            
        },

    },
    created() {
        const token = localStorage.getItem("accessToken");
        const config = {headers: {"X-Authorization": `Bearer ${token}`}};
        this.fetchProfileData(config);
    }
}
</script>
    

<style lang="scss" scoped>
.dataUploadTitle {
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 600;
    font-size: 23px;
    color: #5E5873;
}



@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/pages/page-auth.scss';
</style>